import { useQuery } from "@tanstack/react-query";
import CryptoJS from "crypto-js";
import { toast } from "../utils/toast";

// ✅ AES 복호화 함수
const aesDecrypt = (encryptedData) => {
    const secretKey = CryptoJS.enc.Utf8.parse("a3f2b1o4d5l6f0810abcdef963847857");
    return CryptoJS.AES.decrypt(encryptedData, secretKey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8);
};

// ✅ JWT 토큰 확인 함수
const getJwtToken = () => {
    return localStorage.getItem("token") || null; // JWT 토큰 가져오기
};

// ✅ 로그인된 사용자 ID 가져오는 함수 (API 요청)
const fetchMemberId = async () => {
    const token = getJwtToken();
    if (!token) return null; // 👉 로그인되지 않았으면 null 반환 (API 호출 X)

    const response = await fetch("/api/auth/members/id", {
        headers: { Authorization: `Bearer ${token}` },
    });

    if (!response.ok) {
        throw new Error("로그인 사용자 ID 가져오기 실패");
        // 로그아웃 처리
        localStorage.removeItem("token");
        localStorage.removeItem("userId");

        toast("로그아웃 되었습니다. 다시 로그인 해주세요.");
        window.location.href = "/login"; // 로그인 페이지로 리다이렉트
    }

    const encryptedMemberId = await response.text();
    return aesDecrypt(encryptedMemberId); // AES 복호화 후 반환
};

// ✅ React Query를 활용한 Hook
export const useLoggedInUserId = () => {
    return useQuery({
        queryKey: ["loggedInUserId"],
        queryFn: fetchMemberId,
        enabled: !!getJwtToken(), // 🔥 로그인된 경우에만 API 요청
        staleTime: 1000 * 60 * 5, // 5분 동안 캐싱 유지
        cacheTime: 1000 * 60 * 10,
        retry: 1,
    });
};
